import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__button_mjs_d80dd9e7__ from "../button.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__separator_mjs_58b8de16__ from "../separator.mjs";
import * as __WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__ from "lucide-react";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__filter_context_mjs_5aebc15f__ from "./filter-context.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__core_filter_types_mjs_5f4fde7e__ from "../../core/filter-types.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__core_filter_operators_mjs_3caa67c3__ from "../../core/filter-operators.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__filter_operator_mjs_31a0476c__ from "./filter-operator.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__filter_field_mjs_80b6a0d2__ from "./filter-field.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__filter_value_mjs_4489e0a3__ from "./filter-value.mjs";
function ActiveFilters({ fields: propFields, filters: propFilters, actions: propActions }) {
    const contextData = propFields && propFilters && propActions ? null : (0, __WEBPACK_EXTERNAL_MODULE__filter_context_mjs_5aebc15f__.useFiltersContext)();
    const fields = propFields ?? contextData?.fields ?? [];
    const filters = propFilters ?? contextData?.filters ?? [];
    const actions = propActions ?? contextData?.actions ?? {};
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: filters.map((filter)=>{
            const field = (0, __WEBPACK_EXTERNAL_MODULE__core_filter_types_mjs_5f4fde7e__.getFieldById)(fields, filter.fieldId);
            if (!field) return null;
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ActiveFilter, {
                filter: filter,
                field: field,
                fields: fields,
                actions: actions
            }, `active-filter-${filter.id}`);
        })
    });
}
function ActiveFilter({ filter, field, fields: propFields, actions: propActions }) {
    const contextData = propFields && propActions ? null : (0, __WEBPACK_EXTERNAL_MODULE__filter_context_mjs_5aebc15f__.useFiltersContext)();
    const fields = propFields ?? contextData?.fields ?? [];
    const actions = propActions ?? contextData?.actions ?? {};
    const hasOperator = Boolean(filter.operator);
    const shouldShowValue = hasOperator && (0, __WEBPACK_EXTERNAL_MODULE__core_filter_operators_mjs_3caa67c3__.operatorRequiresValue)(filter.operator);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        className: "flex h-8 items-center rounded-lg border bg-grayscale-dark border-white/10 shadow-xs text-[13px]",
        "data-filter-id": filter.id,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__filter_field_mjs_80b6a0d2__.FilterField, {
                field: field,
                availableFields: fields,
                actions: actions,
                filterId: filter.id
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__separator_mjs_58b8de16__.Separator, {
                orientation: "vertical"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__filter_operator_mjs_31a0476c__.FilterOperator, {
                filter: filter,
                field: field,
                actions: actions
            }),
            shouldShowValue && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__separator_mjs_58b8de16__.Separator, {
                        orientation: "vertical"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__filter_value_mjs_4489e0a3__.FilterValue, {
                        filter: filter,
                        field: field,
                        actions: actions
                    })
                ]
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__separator_mjs_58b8de16__.Separator, {
                orientation: "vertical"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_d80dd9e7__.Button, {
                variant: "ghost",
                className: "rounded-none rounded-r-lg text-xs w-7 h-full hover:text-white/50 active:scale-100",
                onClick: ()=>actions.removeFilter(filter.id),
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.X, {
                    className: "size-4 -translate-x-0.5"
                })
            })
        ]
    });
}
function ActiveFiltersMobileContainer({ children }) {
    const scrollContainerRef = (0, __WEBPACK_EXTERNAL_MODULE_react__.useRef)(null);
    const [showLeftBlur, setShowLeftBlur] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    const [showRightBlur, setShowRightBlur] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(true);
    const checkScroll = ()=>{
        if (scrollContainerRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;
            setShowLeftBlur(scrollLeft > 0);
            setShowRightBlur(scrollLeft + clientWidth < scrollWidth - 1);
        }
    };
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        if (scrollContainerRef.current) {
            const resizeObserver = new ResizeObserver(()=>{
                checkScroll();
            });
            resizeObserver.observe(scrollContainerRef.current);
            return ()=>{
                resizeObserver.disconnect();
            };
        }
    }, []);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        checkScroll();
    }, [
        children
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        className: "relative w-full overflow-x-hidden",
        children: [
            showLeftBlur && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                className: "absolute left-0 top-0 bottom-0 w-16 z-10 pointer-events-none bg-gradient-to-r from-background to-transparent animate-in fade-in-0"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                ref: scrollContainerRef,
                className: "flex gap-2 overflow-x-scroll no-scrollbar",
                onScroll: checkScroll,
                children: children
            }),
            showRightBlur && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                className: "absolute right-0 top-0 bottom-0 w-16 z-10 pointer-events-none bg-gradient-to-l from-background to-transparent animate-in fade-in-0 "
            })
        ]
    });
}
export { ActiveFilter, ActiveFilters, ActiveFiltersMobileContainer };
